export enum ETrailModalLocalKeys {
  trailModalPeriod = 'trailModalPeriod',
  lastShownTrialModal = 'lastShownTrialModal',
}
